import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import type { UserRole } from '../lib/roles';

/**
 * Per-section role guard (ADM-03): assumes RequireAuth already confirmed the visitor is
 * signed in and portal-authorized. Blocks a role that's authorized for the portal but not
 * this specific section (e.g. SUPPORT hitting /user-management) from reaching it via direct
 * URL, not just from seeing it in the menu.
 */
export function ProtectedRoute({
  allowedRoles,
  requiredPermission,
  children,
}: {
  allowedRoles: readonly UserRole[];
  /** Fine-grained gate alongside allowedRoles (ADM-24) — both must pass when set. */
  requiredPermission?: string;
  children: ReactNode;
}) {
  const { portalUser } = useAuth();

  if (!portalUser || !(allowedRoles as UserRole[]).includes(portalUser.role)) {
    return <Navigate to="/404" replace />;
  }

  if (requiredPermission && !portalUser.permissions?.includes(requiredPermission)) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}
